// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__AN6aX","bgOverlay":"styles_bgOverlay__nfat4","mobileLocator":"styles_mobileLocator__oaFHz"};